// Actions for FeatureTable

import FeaturesState, {
    GridCoordinates,
    PreserveFocusData,
    QualityParam,
    SortBy,
    SortOrder,
    SortSetting
} from "../domain/FeaturesState";
import {ActionType, fetchFeatures, startFetching} from "../../../actions/actions";
import * as selectors from "../selectors";
import {NvdbFeature} from "../domain";
import {ServerHolder} from "../components/ContractFeatures";
import {ThunkAction} from 'redux-thunk';
import {AnyAction} from 'redux';
import {AttributeType} from "../../../../integration/datacatalog/datacatalog-services";
import {DownloadThunk} from "../../contract-download/actions";
import {LocationalThunk} from "../../contract-locational-2/actions";

// A thunktype matching the store -- This is used from the actions.ts file -- should move along with the store
export type FeatureThunk = ThunkAction<void, FeaturesState, ServerHolder, AnyAction>;

export enum NavigateDirection {
   UP, DOWN, LEFT, RIGHT
}

export type  Navigate = (direction: NavigateDirection) => FeatureThunk;
export const navigate: Navigate = (direction: NavigateDirection) => (dispatch, getState) => {
    // switch på direction
    // reselect ny GridCoordinates

    console.log('Direction %s', direction);

    let state = getState();
    let {x, y} = selectors.gridFocus(state);

    let gridsize = selectors.gridSize(state);

    switch (direction) {
        case NavigateDirection.DOWN:
            if ( gridsize.y > y + 1 ) {
                y++;
            }
            break;
        case NavigateDirection.RIGHT:
            if ( gridsize.x > x + 1 ) {
                x++;
            }
            break;
        case NavigateDirection.UP:
            if ( y > 0 ) {
                y--;
            }
            break;
        case NavigateDirection.LEFT:
            if ( x > 0 ) {
                x--;
            }
            break;
    }

    // sett ny fokusstate
    dispatch({
        type: ActionType.FEATURETAB3_NAVIGATE,
        gridFocus: new GridCoordinates(x, y)
    })
};

export type SetShowQualityParams = (showQualityParams: boolean) => FeatureThunk;
export const setShowQualityParams: SetShowQualityParams = (showQualityParams: boolean) => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_SHOW_QUALITY_PARAMS,
        showQualityParams
    })
};


export type SetShowOnlyObjektlistAttributes = (showOnlyObjektlistAttributes: boolean) => FeatureThunk;
export const setShowOnlyObjektlistAttributes: SetShowOnlyObjektlistAttributes = (showOnlyObjektlistAttributes: boolean) => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_ONLY_SHOW_OBJECTLIST_ATTRIBUTES,
        showOnlyObjektlistAttributes
    })
};

export type PreserveFocus = (preserveFocusData: PreserveFocusData) => FeatureThunk;
export const preserveFocus: PreserveFocus = (preserveFocus: PreserveFocusData) => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_PRESERVE_FOCUS,
        preserveFocus
    })
};

export type  NavigateTo = (gridCoordinates: GridCoordinates) => FeatureThunk;
export const navigateTo: NavigateTo = (gridCoordinates: GridCoordinates) => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_NAVIGATE,
        gridFocus: gridCoordinates
    })
};

export type  ShowEditor = () => FeatureThunk;
export const showEditor: ShowEditor = () => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_SHOW_EDITOR
    })
};
export type  CloseEditor = () => FeatureThunk;
export const closeEditor: CloseEditor = () => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_CLOSE_EDITOR,
    })
};

export type SortFeatures = (sortBy: SortBy, attributeType: AttributeType, qualityParam: QualityParam) => FeatureThunk;
export const sortFeatures: SortFeatures = (sortBy, attributeType, qualityParam) => (dispatch, getState) => {

    let sortOrder = SortOrder.DESC;

    const {sortSetting: oldSetting, contractId, selectedFeatureType} = getState();
    if (oldSetting &&
        oldSetting.sortBy === sortBy &&
        oldSetting.attribute?.id === attributeType?.id &&
        oldSetting.sortOrder === SortOrder.DESC) {
        sortOrder = SortOrder.ASC;
    }

    const sortSetting = new SortSetting(sortBy, attributeType, qualityParam, sortOrder);
    dispatch({
        type: ActionType.FEATURETAB3_SORT_FEATURES,
        sortSetting
    });
    if(contractId && selectedFeatureType) {
        dispatch(startFetching());
        dispatch(fetchFeatures(contractId, selectedFeatureType.typeId));
    }
}

export type SetShowSubmittedFeatures = (showSubmittedFeatures: boolean) => FeatureThunk;
export const setShowSubmittedFeatures: SetShowSubmittedFeatures = (showSubmittedFeatures) => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_SET_SHOW_SUBMITTED_FEATURES,
        showSubmittedFeatures
    });
}

export type SetShowOnlySelectedFeatures = (showOnlySelectedFeatures: boolean) => FeatureThunk;
export const setShowOnlySelectedFeatures: SetShowOnlySelectedFeatures = (showOnlySelectedFeatures) => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_SET_SHOW_ONLY_SELECTD_FEATURES,
        showOnlySelectedFeatures
    });
}

export type SetUseDescriptiveName = (useDescriptiveName: boolean) => FeatureThunk;
export const setUseDescriptiveName: SetUseDescriptiveName = (useDescriptiveName) => (dispatch) => {
    dispatch({
        type: ActionType.SET_SHOW_DESCRIPTION_INSTEAD_OF_NAME,
        useDescriptiveName
    });
};

export type ShowImportNvdbRoadObjectModal = (roadObject: NvdbFeature) => FeatureThunk;
export const showImportNvdbRoadObjectModal: ShowImportNvdbRoadObjectModal = (roadObject) => (dispatch, getState, serverHolder) => {
    dispatch({
        type: ActionType.FEATURETAB3_SHOW_NVDB_IMPORT_MODAL,
        selectedNvdbRoadObject: roadObject
    })
};


